export default {"src":"/login-app/[GIT_HASH]/_next/static/media/partition_set.12fc6638.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};